import { HelpTooltip } from 'ui/tooltip';
import { colors } from 'ui/theme';
import { TextButton } from 'ui/button';
import { AddMoreSplits } from './SplitEditor.style';
import { SplitEditor } from './enum';

type AddSplitsProps = {
  text: string;
  toolTipText: string;
  onClick: () => void;
  splitEditor: SplitEditor | string;
};

type SplitTestId = SplitEditor | string;

export const addSplitsTestId = (splitEditor: SplitTestId) => `${splitEditor}-add-splits-link`;
export const splitInfoToolTipTestId = (splitEditor: SplitTestId) =>
  `${splitEditor}-absplit-info-tooltip`;

export const AddSplits = ({ text, toolTipText, onClick, splitEditor }: AddSplitsProps) => (
  <AddMoreSplits>
    <TextButton data-test={addSplitsTestId(splitEditor)} onClick={onClick}>
      {text}
    </TextButton>
    <HelpTooltip
      tooltipContent={toolTipText}
      iconProps={{
        color: colors.secondaryText,
        'data-test': splitInfoToolTipTestId(splitEditor),
      }}
    />
  </AddMoreSplits>
);
